import BaseService from '@src/services/BaseService'

class WorkdayItemService extends BaseService {
    constructor() {
        super('workday-items')
    }
}
export default new WorkdayItemService()
